export const STRING = {
  EMPTY: "",
  DOT: ".",
  DELIMITER: {
    DOT: ". ",
    COMMA: ", ",
  },
} as const;
